var map = {
	"./argon-1.png": 9477,
	"./bi2o3-1.png": 3927,
	"./hbn-1.png": 2054,
	"./laplace-1.png": 6120,
	"./nuclear-bomb-1.png": 8523,
	"./quantum-waves-1.png": 4392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4708;